var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVolumeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z",
    transform: "translate(-73 -1207) translate(24 464) translate(49 743)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M8.889 16H5c-.552 0-1-.448-1-1V9c0-.552.448-1 1-1h3.889l5.294-4.332c.15-.123.356-.148.531-.065.175.083.286.259.286.452v15.89c0 .193-.111.37-.286.452-.175.083-.381.058-.531-.065L8.89 16h-.001zm9.974.591l-1.422-1.422c.984-.757 1.56-1.928 1.559-3.169 0-1.43-.75-2.685-1.88-3.392l1.439-1.439C20.095 8.299 21.002 10.093 21 12c0 1.842-.83 3.49-2.137 4.591z",
    transform: "translate(-73 -1207) translate(24 464) translate(49 743)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVolumeWhite);
export default __webpack_public_path__ + "static/media/ic-volume-white.31d2c871.svg";
export { ForwardRef as ReactComponent };